import { render, staticRenderFns } from "./NewFolderDialog.vue?vue&type=template&id=55e5fc12&scoped=true"
import script from "./NewFolderDialog.vue?vue&type=script&lang=ts"
export * from "./NewFolderDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e5fc12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55e5fc12')) {
      api.createRecord('55e5fc12', component.options)
    } else {
      api.reload('55e5fc12', component.options)
    }
    module.hot.accept("./NewFolderDialog.vue?vue&type=template&id=55e5fc12&scoped=true", function () {
      api.rerender('55e5fc12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialogs/NewFolderDialog.vue"
export default component.exports